import React from 'react';
import { AwardIcon, BanknoteIcon, LayersIcon, PercentIcon, CheckCircleIcon, ClockIcon, RefreshCwIcon } from 'lucide-react';
import { formatZAR } from '../hooks/useMavisData';
const commissionTiers = [{
  name: 'Bronze',
  range: 'R0 - R50k',
  rate: '3.0%',
  vendors: 45,
  paid: 42500,
  color: 'bg-orange-100 text-orange-800 border-orange-200'
}, {
  name: 'Silver',
  range: 'R50k - R150k',
  rate: '4.5%',
  vendors: 32,
  paid: 125000,
  color: 'bg-gray-100 text-gray-800 border-gray-200'
}, {
  name: 'Gold',
  range: 'R150k - R300k',
  rate: '5.5%',
  vendors: 18,
  paid: 215000,
  color: 'bg-yellow-100 text-yellow-800 border-yellow-200'
}, {
  name: 'Platinum',
  range: 'R300k+',
  rate: '7.0%',
  vendors: 8,
  paid: 345000,
  color: 'bg-blue-100 text-blue-800 border-blue-200'
}];
const recentPayouts = [{
  date: '2023-10-25',
  vendor: 'Sipho Spaza Shop',
  tier: 'Platinum',
  sales: 345000,
  rate: '7.0%',
  payout: 24150,
  status: 'Paid'
}, {
  date: '2023-10-25',
  vendor: 'Mama Joy Supermarket',
  tier: 'Gold',
  sales: 210000,
  rate: '5.5%',
  payout: 11550,
  status: 'Processing'
}, {
  date: '2023-10-24',
  vendor: 'Kasi Convenience',
  tier: 'Silver',
  sales: 115000,
  rate: '4.5%',
  payout: 5175,
  status: 'Paid'
}, {
  date: '2023-10-24',
  vendor: 'Boksburg Corner Store',
  tier: 'Silver',
  sales: 98000,
  rate: '4.5%',
  payout: 4410,
  status: 'Pending'
}, {
  date: '2023-10-23',
  vendor: 'Thabo Electronics',
  tier: 'Bronze',
  sales: 45000,
  rate: '3.0%',
  payout: 1350,
  status: 'Paid'
}, {
  date: '2023-10-23',
  vendor: 'Zanele Mini Market',
  tier: 'Silver',
  sales: 76000,
  rate: '4.5%',
  payout: 3420,
  status: 'Paid'
}, {
  date: '2023-10-22',
  vendor: 'Benoni Fresh Produce',
  tier: 'Silver',
  sales: 65000,
  rate: '4.5%',
  payout: 2925,
  status: 'Paid'
}, {
  date: '2023-10-22',
  vendor: 'Kempton Express',
  tier: 'Silver',
  sales: 58000,
  rate: '4.5%',
  payout: 2610,
  status: 'Pending'
}, {
  date: '2023-10-21',
  vendor: 'Dube Trading',
  tier: 'Bronze',
  sales: 32000,
  rate: '3.0%',
  payout: 960,
  status: 'Paid'
}, {
  date: '2023-10-21',
  vendor: 'Mamelodi Super',
  tier: 'Gold',
  sales: 185000,
  rate: '5.5%',
  payout: 10175,
  status: 'Paid'
}];
export function Commissions() {
  return <div className="p-8 max-w-7xl mx-auto animate-in fade-in duration-500" data-id="element-717">
      <div className="mb-8" data-id="element-718">
        <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-719">Commissions</h1>
        <p className="text-gray-500" data-id="element-720">
          Create and manage vendor commission structures and payouts.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8" data-id="element-721">
        <div className="bg-white p-4 rounded-none border border-gray-100 shadow-sm flex items-center gap-4" data-id="element-722">
          <div className="p-3 bg-mavis-green/10 text-mavis-green rounded-none" data-id="element-723">
            <BanknoteIcon className="w-5 h-5" data-id="element-724" />
          </div>
          <div data-id="element-725">
            <p className="text-xs text-gray-500 font-medium uppercase" data-id="element-726">
              Total Paid (MTD)
            </p>
            <p className="text-xl font-bold text-gray-900 font-mono" data-id="element-727">
              {formatZAR(142500)}
            </p>
          </div>
        </div>
        <div className="bg-white p-4 rounded-none border border-gray-100 shadow-sm flex items-center gap-4" data-id="element-728">
          <div className="p-3 bg-mavis-orange/10 text-mavis-orange rounded-none" data-id="element-729">
            <ClockIcon className="w-5 h-5" data-id="element-730" />
          </div>
          <div data-id="element-731">
            <p className="text-xs text-gray-500 font-medium uppercase" data-id="element-732">
              Pending Payouts
            </p>
            <p className="text-xl font-bold text-gray-900 font-mono" data-id="element-733">
              {formatZAR(23400)}
            </p>
          </div>
        </div>
        <div className="bg-white p-4 rounded-none border border-gray-100 shadow-sm flex items-center gap-4" data-id="element-734">
          <div className="p-3 bg-mavis-blue/10 text-mavis-blue rounded-none" data-id="element-735">
            <LayersIcon className="w-5 h-5" data-id="element-736" />
          </div>
          <div data-id="element-737">
            <p className="text-xs text-gray-500 font-medium uppercase" data-id="element-738">
              Active Tiers
            </p>
            <p className="text-xl font-bold text-gray-900 font-mono" data-id="element-739">4</p>
          </div>
        </div>
        <div className="bg-white p-4 rounded-none border border-gray-100 shadow-sm flex items-center gap-4" data-id="element-740">
          <div className="p-3 bg-mavis-teal/10 text-mavis-teal rounded-none" data-id="element-741">
            <PercentIcon className="w-5 h-5" data-id="element-742" />
          </div>
          <div data-id="element-743">
            <p className="text-xs text-gray-500 font-medium uppercase" data-id="element-744">
              Avg Rate
            </p>
            <p className="text-xl font-bold text-gray-900 font-mono" data-id="element-745">5.2%</p>
          </div>
        </div>
      </div>

      <h2 className="text-lg font-bold text-gray-900 mb-4" data-id="element-746">Commission Tiers</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-747">
        {commissionTiers.map((tier, i) => <div key={i} className="bg-white rounded-none border border-gray-200 shadow-sm overflow-hidden" data-id="element-748">

            <div className={`p-4 border-b ${tier.color} flex justify-between items-center`} data-id="element-749">

              <h3 className="font-bold uppercase tracking-wider text-sm" data-id="element-750">
                {tier.name}
              </h3>
              <AwardIcon className="w-5 h-5 opacity-70" data-id="element-751" />
            </div>
            <div className="p-5" data-id="element-752">
              <div className="mb-4" data-id="element-753">
                <p className="text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-754">
                  Sales Range
                </p>
                <p className="font-mono font-medium text-gray-900" data-id="element-755">
                  {tier.range}
                </p>
              </div>
              <div className="mb-4" data-id="element-756">
                <p className="text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-757">
                  Commission Rate
                </p>
                <p className="text-3xl font-bold text-mavis-teal font-mono" data-id="element-758">
                  {tier.rate}
                </p>
              </div>
              <div className="grid grid-cols-2 gap-4 pt-4 border-t border-gray-100" data-id="element-759">
                <div data-id="element-760">
                  <p className="text-xs text-gray-500 mb-1" data-id="element-761">Vendors</p>
                  <p className="font-mono font-bold text-gray-900" data-id="element-762">
                    {tier.vendors}
                  </p>
                </div>
                <div data-id="element-763">
                  <p className="text-xs text-gray-500 mb-1" data-id="element-764">Total Paid</p>
                  <p className="font-mono font-bold text-gray-900" data-id="element-765">
                    {formatZAR(tier.paid)}
                  </p>
                </div>
              </div>
            </div>
          </div>)}
      </div>

      <div className="bg-white rounded-none shadow-sm border border-gray-200 overflow-hidden" data-id="element-766">
        <div className="p-5 border-b border-gray-200 bg-gray-50 flex justify-between items-center" data-id="element-767">
          <h2 className="text-lg font-bold text-gray-900" data-id="element-768">
            Recent Commission Payouts
          </h2>
          <button className="text-sm font-medium text-mavis-teal hover:underline" data-id="element-769">
            Download Report
          </button>
        </div>
        <div className="overflow-x-auto" data-id="element-770">
          <table className="w-full text-left border-collapse" data-id="element-771">
            <thead data-id="element-772">
              <tr className="bg-gray-50 text-gray-500 text-xs uppercase tracking-wider border-b border-gray-200" data-id="element-773">
                <th className="p-4 font-medium" data-id="element-774">Date</th>
                <th className="p-4 font-medium" data-id="element-775">Vendor</th>
                <th className="p-4 font-medium" data-id="element-776">Tier</th>
                <th className="p-4 font-medium text-right" data-id="element-777">Sales Amount</th>
                <th className="p-4 font-medium text-right" data-id="element-778">Rate</th>
                <th className="p-4 font-medium text-right" data-id="element-779">Payout</th>
                <th className="p-4 font-medium" data-id="element-780">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100" data-id="element-781">
              {recentPayouts.map((payout, i) => <tr key={i} className="hover:bg-gray-50 transition-colors" data-id="element-782">
                  <td className="p-4 text-sm text-gray-600" data-id="element-783">{payout.date}</td>
                  <td className="p-4 text-sm font-medium text-gray-900" data-id="element-784">
                    {payout.vendor}
                  </td>
                  <td className="p-4" data-id="element-785">
                    <span className={`inline-flex items-center px-2 py-0.5 rounded-none text-[10px] font-bold uppercase tracking-wider border ${payout.tier === 'Platinum' ? 'bg-blue-100 text-blue-800 border-blue-200' : payout.tier === 'Gold' ? 'bg-yellow-100 text-yellow-800 border-yellow-200' : payout.tier === 'Silver' ? 'bg-gray-100 text-gray-800 border-gray-200' : 'bg-orange-100 text-orange-800 border-orange-200'}`} data-id="element-786">

                      {payout.tier}
                    </span>
                  </td>
                  <td className="p-4 text-sm font-mono text-gray-600 text-right" data-id="element-787">
                    {formatZAR(payout.sales)}
                  </td>
                  <td className="p-4 text-sm font-mono text-gray-600 text-right" data-id="element-788">
                    {payout.rate}
                  </td>
                  <td className="p-4 text-sm font-mono font-bold text-gray-900 text-right" data-id="element-789">
                    {formatZAR(payout.payout)}
                  </td>
                  <td className="p-4" data-id="element-790">
                    <span className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-none text-xs font-medium ${payout.status === 'Paid' ? 'bg-green-100 text-green-800' : payout.status === 'Pending' ? 'bg-orange-100 text-orange-800' : 'bg-blue-100 text-blue-800'}`} data-id="element-791">

                      {payout.status === 'Paid' && <CheckCircleIcon className="w-3 h-3" data-id="element-792" />}
                      {payout.status === 'Pending' && <ClockIcon className="w-3 h-3" data-id="element-793" />}
                      {payout.status === 'Processing' && <RefreshCwIcon className="w-3 h-3 animate-spin" data-id="element-794" />}
                      {payout.status}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}